export const SHOW_HEADER_CHAT_ICON = true;

/** Temporarily hide the floating AFOMA chatbot widget. Set true to re-enable. */
export const SHOW_CHATBOT = false;
